import { EUserLanguage } from '@miotech/esghub-web-lib-common';
import { getLocale, uuid } from '@miotech/shared';
import _ from 'lodash';
import THEME from 'styles/colors';

// 校验数据是否为null或undefined
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNull(obj: any) {
  if (obj === null || obj === undefined) {
    return true;
  }
  return false;
}

// 校验数据是否为空（包含null、undefined、空字符串、空数组以及空对象）
// 不包括数字为零、布尔值为false的情况
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValEmpty(obj: any) {
  if (isNull(obj)) {
    return true;
  }
  if (typeof obj === 'string') {
    return obj.length === 0;
  }
  if (obj instanceof Array) {
    return obj.length === 0;
  }
  if (obj instanceof Object) {
    return Object.keys(obj).length === 0;
  }
  return false;
}

export function getHighlightHtml(query?: string, text?: string) {
  if (!text || !query) {
    return text || '';
  }
  return query.length
    ? text.replace(
        RegExp(_.escapeRegExp(query.trim()), 'ig'),
        match => `<span style="color: ${THEME.branding}">${match}</span>`,
      )
    : text;
}

interface IListItem<T> {
  children?: T[];
  getChildren?: () => T[];
  getParent?: () => T[];
}

type TArrayType<T> = Array<T & IListItem<T>>;

export function getDeepChildren<T>({
  allList,
  selfKey,
  parentKey,
  baseList,
  level = 0,
  getChildren: getParentChildren,
  parent = [],
}: {
  allList: TArrayType<T>;
  selfKey: keyof T;
  parentKey: keyof T;
  baseList?: TArrayType<T>;
  level?: number;
  getChildren?: (v: TArrayType<T>) => void;
  parent?: TArrayType<T>;
}): TArrayType<T> {
  const res = [];

  const loopList = [...(baseList ? baseList : allList.filter(x => isValEmpty(x[parentKey])))];

  for (let index = 0; index < loopList.length; index++) {
    const element = loopList[index];

    //当前元素的所有子集
    const totalChildren: TArrayType<T> = [];

    const getChildren = (itemChildren: TArrayType<T>) => {
      totalChildren.push(...itemChildren);
      getParentChildren?.(itemChildren);
    };

    const childrenList = [...allList.filter(item => item[parentKey] === element[selfKey])];

    const children = getDeepChildren({
      allList,
      selfKey,
      parentKey,
      baseList: childrenList,
      level: level + 1,
      getChildren,
      parent: _.compact([...parent, element]),
    });

    const item = {
      ...element,
      key: element[selfKey],
      children,
      level,
      getChildren: () => _.uniqBy(totalChildren, selfKey),
      getParent: () => _.compact([...parent]),
    };

    getParentChildren?.([item, ...children]);

    res.push(item);
  }

  return res;
}

export function getIsEnLanguage() {
  return (getLocale() as string) === EUserLanguage.EN_US;
}

export function replaceAllSpace(str: string) {
  return _.replace(str, /\s/g, '');
}

// 只识别中文，非中文默认使用英文
export function getLanguageByNavigatorLanguage(language: string) {
  switch (language) {
    case 'zh':
    case 'zh-CN':
    case 'zh-SG':
      return EUserLanguage.ZH_CN;
    case 'zh-TW':
    case 'zh-HK':
    case 'zh-MO':
      return EUserLanguage.ZH_HK;
  }
  return EUserLanguage.EN_US;
}

export const getUuidName = (fileName: string) => {
  const filePath = fileName.split('.');

  const fileExtension = filePath.pop();
  const name = filePath.join('.');
  return `${name}-${uuid()}.${fileExtension}`;
};
